import React from 'react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';

import launchDarklyToggles, {
  DARKLY_TOGGLE_NAMES,
} from '../../../../main-deprecated/utils/launchDarklyToggles';
import Timekeeping from '../../timekeeping/Timekeeping';
import TimekeepingV2 from '../../timekeeping/TimekeepingV2';

const TimekeepingRouteGateComponent = ({ flags }) => {
  const isEnabled =
    launchDarklyToggles(flags, DARKLY_TOGGLE_NAMES.hb5111TimecardViewV2GlobalFilters) === true;

  return isEnabled ? <TimekeepingV2 /> : <Timekeeping />;
};

TimekeepingRouteGateComponent.propTypes = {
  flags: PropTypes.shape({}),
};

export const TimekeepingRouteGate = TimekeepingRouteGateComponent;

export default withLDConsumer()(TimekeepingRouteGateComponent);
